// Used in many components

import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "pp-tool-tip",
    templateUrl: "./pp-tooltip.component.html",
    styleUrls: ["./pp-tooltip.component.scss"],
    standalone: false
})
export class PPToolTipComponent implements OnInit {
    @Input() text = "";
    @Input() tooltipType = "mainPage";
    @Input() top = "";
    @Input() left = "";
    @Input() progressStatus = "";
    @Input() completeDate = "";
    @Input() timeSpent = "";

    show = false;
    title = "";

    constructor() {}

    getColor(progressStatus: string) {
        switch (progressStatus) {
            default:
                return "#FF6C00";
        }
    }

    ngOnInit() {}
}
